<template>
  <q-input
    ref="input"
    type="email"
    placeholder="Enter Email..."
    v-bind="$attrs"
  >
    <template v-for="[slot, args] of Object.entries($slots)" #[slot]>
      <slot :name="slot" v-bind="args" />
    </template>

    <template v-if="withIcon" #prepend>
      <q-icon name="mdi-email" />
    </template>
  </q-input>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    withIcon: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    focus () {
      this.$refs.input.focus()
    }
  }
}
</script>
